module.exports = __webpack_public_path__ + "assets/CircleInTriangleDetailed.f060552103bf733033bf8a75dc7b0830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleInTriangleDetailed.png
// module id = 489
// module chunks = 0